export const theme = {
  titleFont: 'Ubuntu',
  mainFont: 'Roboto',

  black: 'rgb(10,10,10)',
  textArea: 'rgb(243, 247, 251)',
  green: '#2ECC40',
  orange: '#FF851B'
};
